import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-640">
      <PriceAlert data-id="element-641" />
      <Hero data-id="element-642" />
      <Testimonial data-id="element-643" />
      <ProblemSolution data-id="element-644" />
      <ValueStack data-id="element-645" />
      <ModuleBreakdown data-id="element-646" />
      <Guarantee data-id="element-647" />
      <PricingSection data-id="element-648" />
      <Footer data-id="element-649" />
      <RecentPurchaseToast data-id="element-650" />
    </div>;
}